'use client';

import { useUserInfoContext } from 'providers/auth-provider/user-info-provider';
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { GetCartResponseModel } from '../api';
import { cartService } from '../services';

type TCartContext = {
  cart: GetCartResponseModel | undefined;
  setCart: (cart: GetCartResponseModel | undefined) => void;
  cartIsLoading: boolean;
};

const CartContext = createContext<TCartContext>({
  cart: undefined,
  setCart: () => void 0,
  cartIsLoading: false,
});

type TCartProviderProps = {
  children: ReactNode;
};

export const CartProvider = ({ children }: TCartProviderProps): JSX.Element => {
  const [cart, setCart] = useState<GetCartResponseModel | undefined>();
  const { profile } = useUserInfoContext();
  const [cartIsLoading, setCartIsLoading] = useState(false);

  useEffect(() => {
    setCartIsLoading(true);
    void cartService
      .getCart()
      .then(setCart)
      .finally(() => setCartIsLoading(false));
  }, [profile]);

  return (
    <CartContext.Provider value={{ cart, setCart, cartIsLoading }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCartContext = (): TCartContext => useContext(CartContext);
